import { Link } from "react-router-dom";

const ScreenHeader = (props) => {
  const { screenHeaderTitle = "" } = props;
  return (
    <div className='d-flex gap-4 align-items-center mb-4'>
      <h3 className='mb-0'>{screenHeaderTitle}</h3>
      <Link to='/' className='my-auto  ms-auto me-1 btn btn-primary' style={{ maxHeight: "38px" }}>
        <span>Volver</span>
      </Link>
    </div>
  );
};

export default ScreenHeader;
